import { AvaSuburbs } from '@models';

export const fillPostcode = (suburbs: AvaSuburbs[]): AvaSuburbs[] =>
  suburbs.map((suburb) => ({
    ...suburb,
    suburb_postcode: `${suburb.key.split('_')[0]}`,
  }));

export const fillPostcodeAndName = (suburbs: AvaSuburbs[]): AvaSuburbs[] =>
  suburbs.map((suburb) => ({
    ...suburb,
    suburb_postcode: `${suburb.key.split('_')[0]} ${suburb.suburb_name}`,
  }));
